<template>
  <div class="animated fadeIn">
    <b-row>
      <PageTitle></PageTitle>
      <filter-area
        @filterData="filterData()"
        @resetData="resetFilerAreaData()"
      >
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="procedures">{{$tc('filterArea.label.procedure', 1)}}</label>
              <v-select id="procedures" v-model="filterArea.procedureCode" index="code" :options="procedures" multiple></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="sources">{{$tc('filterArea.label.source', 1)}}</label>
              <v-select id="sources" v-model="filterArea.sourceCode" index="code" :options="sources" multiple></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label for="models">{{$tc('filterArea.label.model', 1)}}</label>
              <v-select id="models" v-model="filterArea.modelCode" :options="models" multiple :getOptionLabel="getParsedModels"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </filter-area>

      <b-col lg="12">
        <b-card>
          <b-table
            :stacked="stacked"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="items"
            :fields="captions"
            :current-page="1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :per-page="perPage"
            @sort-changed="sortingChanged"
            :no-sort-reset="true"
            :no-local-sorting="true">
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <router-link tag="button" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')"
                             :to="{name: 'procedureModelShowRoute', params:{id: data.item.id}}">
                </router-link>
                <router-link tag="button" class="btn btn-warning fa fa-edit" v-b-tooltip.hover :title="$t('actions.edit')"
                             :to="{name: 'procedureModelEditRoute', params:{id: data.item.id}}">
                </router-link>
                <button class="btn btn-danger" v-b-tooltip.hover :title="$t('actions.delete')" @click="handleDelete(data.item)">
                  <i class="far fa-trash" />
                </button>
              </div>
            </template>
          </b-table>

          <div class="row d-flex justify-content-between">
            <div class="col-sm-4">
              <b-pagination :total-rows="rowCount" :per-page="perPage" v-model="currentPage"
                            :prev-text="$t('actions.previous')"
                            :next-text="$t('actions.next')"
                            hide-goto-end-buttons @input="fetchData(currentPage)"/>
            </div>
            <div class="col-sm-2">
              <router-link class="btn btn-primary btn-block float-right" role="button" :to="{path: `/procedureModels/new`}" push>
                {{ $t('actions.create') }}
              </router-link>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Eliminazione Associazione Prestazione - Modello" class="modal-danger" v-model="deleteModal" @ok="deleteProcedureModel"
             ok-variant="danger" v-if="selectedProcedureModel">
      {{ $t('procedureModel.message.deleteMessage') }}
    </b-modal>
  </div>
</template>
<script>
import PageTitle from '@/components/PageTitle'
import i18n from '@/config/i18n'
import FilterArea from '../../components/FilterArea'
import miniToastr from 'mini-toastr' //ES6
import SourceService from "@/services/SourceService";
import ProcedureService from "@/services/ProcedureService";
import vSelect from 'vue-select'
import ModelService from "@/services/ModelService";
import ProcedureModelService from "@/services/ProcedureModelService";

const sourceService = SourceService.build()
const procedureService = ProcedureService.build();
const modelService = ModelService.build();
const procedureModelService = ProcedureModelService.build();

export default {
  name: 'ProcedureModelList',
  inheritAttrs: false,
  components: {
    PageTitle,
    FilterArea,
    vSelect
  },
  props: {
    caption: {
      type: String,
      default: 'Associazioni Prestazione - Modello'
    },
    stacked: {
      type: String,
      default: 'sm'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 7
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          label: i18n.t('page.generic.code')
        },
        {
          key: 'procedureLabel',
          sortable: true,
          label: i18n.t('procedureModel.procedureLabel'),
        },
        {
          key: 'sourceLabel',
          sortable: false,
          label: i18n.tc('title.sources', 0)
        },
        {
          key: 'modelLabel',
          sortable: true,
          label: i18n.t('procedureModel.modelLabel'),
        },
        {
          key: 'modelDescription',
          sortable: true,
          label: i18n.t('procedureModel.modelDescription'),
        },
        {
          key: 'actions',
          sortable: false,
          label: 'Azioni'
        }
      ],
      currentPage: 1,
      tableData: [],
      tableTotalRows: 0,
      sortBy: 'code',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      activeRadioOptions: [
        {text: 'Attivo',value: true},
        {text: 'Disattivo',value: false},
      ],
      filterArea: {
        procedureCode: null,
        sourceCode: null,
        modelCode: null
      },
      deleteModal: false,
      selectedProcedureModel: null,
      procedures: [],
      sources: [],
      models: []
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData(1);
    this.getProcedures();
    this.getSources();
    this.getModels();
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : []
    },
    captions: function () {
      return this.fields
    },
    rowCount: function () {
      return this.tableTotalRows
    },
    encodedModelFilter: function () {
      return this.filterArea.modelCode.map((model) => model.code);
    }
  },
  methods: {
    async fetchData(currentPage) {
      (
        {
          data: this.tableData = [],
          total: this.tableTotalRows = 0
        } = await procedureModelService.search(
          {
            max: this.perPage,
            offset: (currentPage - 1) * this.perPage,
            order: (this.sortDesc ? 'desc' : 'asc'),
            procedureCode: this.filterArea.procedureCode,
            modelCode: this.filterArea.modelCode ? this.encodedModelFilter : null,
            sourceCode: this.filterArea.sourceCode
          }
        )
      )
    },
    getParsedModels(model) {
      return model.code + ' ' + model.description
    },
   async getModels() {
      this.models = (await modelService.search({ max: -1 })).data;
    },
   async getSources() {
      this.sources = (await sourceService.search({ max: -1 })).data;
   },
    async getProcedures() {
      this.procedures = (await procedureService.search({ max: -1 })).data;
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.fetchData(this.currentPage)
    },
    filterData(){
      this.fetchData(1)
    },
    procedureTypeFormatter(procedureType) {
      return procedureType.label
    },
    sourceFormatter(source) {
      return source.label;
    },
    resetFilerAreaData(){
      this.filterArea = {
        procedureCode: null,
        sourceCode: null,
        modelCode: null,
      };
      this.fetchData(1)
    },
    handleDelete(procedureModel) {
      this.deleteModal = true;
      this.selectedProcedureModel = procedureModel;
    },
    async deleteProcedureModel() {
      try {
        // TODO Aggiungere verifica sui consensi pendenti
        await procedureModelService.destroy(this.selectedProcedureModel.id);
        await this.fetchData(1);
        miniToastr.info("Associazione Prestazione Modello con successo!")
      } catch (exception) {
        miniToastr.error(exception.message)
      } finally {
        this.selectedProcedureModel = null;
      }
    }
  }
}
</script>

